import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const SosXRayService = {
    apply: async (payload) => axios.post(`${API_URL}/sos_x_ray/apply`, payload).then(({data}) => data.data).catch((err) => { throw err }),
    getAllEventProvidences: async () => axios.get(`${API_URL}/sos/allProvidences`).then(({data}) => data.map(el => ({value: el.id, label: el.text}))).catch((err) => { throw err }),
    getAllProtectionProgram: async () => axios.get(`${API_URL}/sos/allProtectionProgram`).then(({data}) => data.map(el => ({value: el.id, label: el.text}))).catch((err) => { throw err }),
};

export default SosXRayService;